import React from 'react';
import './footer-sidebar.css';
import gascoEducaMono from '../../assets/images/gasco_educa_mono.png'
import fundacionMono from '../../assets/images/fundacion_mono.png'
import salaGascoMono from '../../assets/images/salagasco_mono.png'
import gascoGlpMono from '../../assets/images/gasco_glp_mono.png'
import ministerioCulturaMono from '../../assets/images/ministerio_cultura_mono.png'
import donacionesCulturalesMono from '../../assets/images/donaciones_culturales_mono.png'

const FooterSidebar = () => {
  return (
    <footer className="footer-nav-mockup">
      <div className="footer-top-row">
        <div className="footer-info-col">
          <strong>Visítanos</strong>
          <p>Santo Domingo 1061, Santiago de Chile<br />Metro Plaza de Armas</p>
          <p>Abierto 9:00 a 17:00 hrs</p>
        </div>
        <div className="footer-info-col">
          <strong>Contacto</strong>
          <p><a href="mailto:contacto@fundaciongasco.cl">contacto@fundaciongasco.cl</a></p>
          <p><a href="tel:+56912312312">+56 9 1231 2312</a></p>
        </div>
        <div className="footer-info-col">
          <strong>Síguenos</strong>
          <p>
            <a href="https://www.instagram.com/fundaciongasco/" target="_blank" rel="noreferrer">Instagram</a> /
            {' '}
            <a href="https://www.facebook.com/SalaGascoArteContemporaneo/" target="_blank" rel="noreferrer">Facebook</a>
          </p>
        </div>
        <div className="footer-info-col">
          <a href="https://fundaciongasco.cl/planifica-tu-visita/" className="footer-cta">Planifica tu visita →</a>
        </div>
      </div>

      <div className="footer-logos-row">
        <div className="footer-logos-group">
          <a href="https://www.gascoeduca.cl" title="Gasco Educa">
            <img src={gascoEducaMono} alt="Logo Gasco Educa" />
          </a>
          <a href="https://fundaciongasco.cl" title="Fundación Gasco">
            <img src={fundacionMono} alt="Logo Fundación Gasco" />
          </a>
          <a href="https://www.salagasco.cl" title="Sala Gasco">
            <img src={salaGascoMono} alt="Logo Sala Gasco" />
          </a>
        </div>
        <div className="footer-logos-group">
          <a href="https://www.gasco.cl">
            <img src={gascoGlpMono} alt="Logo Gasco" className="gasco-logo-small" />
          </a>
          <a href="https://www.cultura.gob.cl/">
            <img src={ministerioCulturaMono} alt="Ministerio de las Culturas, las Artes y el Patrimonio" />
          </a>
          <a href="https://donacionesculturales.gob.cl/">
            <img src={donacionesCulturalesMono} alt="Ley de Donaciones Culturales" />
          </a>
        </div>
      </div>
    </footer>
  )
}

export default FooterSidebar; 
